import { getUrl } from '@/utils/request';

function qqLogin(params) {
  window.location.href = getUrl('qq/login', params);
}

function wechatLogin(params) {
  window.location.href = getUrl('wechat/login', params);
}

function getRedirectUrl() {
  const [href, search] = window.location.href.split('?');

  // 登录成功之后，重定向给 url 带上 logined 参数，以用来统计登录成功的用户
  return `${href}?${search}&logined`;
}

export default function doLogin(sid, platforms, onError) {
  const ua = navigator.userAgent.toLowerCase();
  const wechatRE = /micromessenger/;
  const params = { redirect_url: getRedirectUrl() };
  let curPlat = '';

  if (platforms.includes('qq')) {
    curPlat = 'qq';
  }

  if (platforms.includes('wx') && wechatRE.test(ua)) {
    curPlat = 'wx';
  }

  switch (curPlat) {
    case 'wx':
      wechatLogin(params);
      break;

    case 'qq':
      qqLogin(params);
      break;

    default:
      onError();
  }
}
